import { Box, Typography } from '@mui/material';

export const AndOperatorLabel = () => {
  return (
    <Box position="relative">
      <Typography
        variant="caption"
        color="text.primary"
        fontWeight={600}
        sx={{
          position: 'absolute',
          top: -9,
          left: '30px',
        }}
      >
        AND
      </Typography>
    </Box>
  );
};
